module.exports = __webpack_public_path__ + "b50f856afc10982fce68c50ca0f2009d.jpg";